import { BonusAnalysisResult } from "@bonusmap/api-types";
import { BaBase } from "./ba-base.js";
import { BootstrapOffcanvas } from "../../types/bootstrap.js";
import { BlockAnalyzed } from "./block-analyzed.js";
import { BlockAnalyzedDate } from "./block-analyzed-date.js";
import { BlockAnalyzedAmbito } from "./block-analyzed-ambito.js";
import { BlockAnalyzedLinks } from "./block-analyzed-links.js";
import { BlockAnalyzedParameters } from "./block-analyzed-parameters.js";
import { toastInfo, toastSuccess } from "../../toasts.js";
import { bonusAiStorage } from "./bonus-ai-storage.js";
import { BonusFileComponent } from "../bonus-file/bonus-file.js";

// Pannello di lavoro
export class BaPanel extends BaBase {
    static override webComponentName: string = "ba-panel";
    protected override _templateId: string = "ba-panel";
    /** Bootstrap Offcanvas instance */
    private offcanvasInstance: BootstrapOffcanvas | null = null;

    /** Offcanvas container element */
    private offcanvasElement: HTMLElement | null = null;
    public get btnTogglePanel(): HTMLButtonElement | null {
        return this.roleElementSelector('toggle-panel-button')! as HTMLButtonElement | null;
    }
    public get btnApplyAll(): HTMLButtonElement | null {
        return this.roleElementSelector('apply-all')! as HTMLButtonElement | null;
    }
    public get currentAnalysData(): BonusAnalysisResult | null {
        return this.BaParent ? this.BaParent.currentAnalysData : null;
    }
    public get currentFileBase64(): string | null {
        return bonusAiStorage.get();
    }
    async setupFile(): Promise<void> {
        const bonusFileEl = document.querySelector('bonus-file') as BonusFileComponent | null;
        if (bonusFileEl && this.currentFileBase64) {
           const success = await bonusFileEl.setBase64File(this.currentFileBase64, 'analysed-file.pdf', 'application/pdf');
           if(success) {
                console.log("BaPanel: File caricato correttamente in bonus-file.");
           }
        }
    }
    constructor() {
        super();
    }
    protected onConnected(): void {
        super.onConnected();
        this.setupFile()
            .then(() => {
                toastInfo('Il file analizzato è stato caricato automaticamente');
            })
            .catch((error) => {
                console.error("BaPanel: Error setting up file.", error);
            });
    }
    protected buildRenderingData(): Record<string, any> {
        const baseData = super.buildRenderingData();
        return {
            ...baseData,
            analysData: this.currentAnalysData
        };
    }

    protected afterRender(): void {
        super.afterRender();
        this.offcanvasElement = this.querySelector(`#panel-${this.componentId}`);
        if (this.offcanvasElement) {
            this.offcanvasInstance = new window.bootstrap.Offcanvas(this.offcanvasElement, {
                backdrop: false,
                keyboard: true
            });
        }
        const getDataBaseCollectorEl = () => {
            // data-base-collector ha la classe .container di bootstrap
            // quando è aperto l'offcanvas il .container deve essere rimosso 
            // e deve essere aggiunta la classe .container-ai-offset
            // quando si chiude l'offcanvas deve essere rimossa la classe .container-ai-offset
            return document.querySelector('data-base-collector');
        }
        this.offcanvasElement?.addEventListener('hidden.bs.offcanvas', () => {
            const baseCollector = getDataBaseCollectorEl();
            if (baseCollector) {
                baseCollector.classList.remove('container-ai-offset');
            }
            // hidden.bs.offcanvas
            this.btnTogglePanel!.querySelector('.p-open')?.classList.remove('d-none');
            this.btnTogglePanel!.querySelector('.p-close')?.classList.add('d-none');
        });
        this.offcanvasElement?.addEventListener('shown.bs.offcanvas', () => {
            const baseCollector = getDataBaseCollectorEl();
            if (baseCollector) {
                baseCollector.classList.add('container-ai-offset');
            }
            this.btnTogglePanel!.querySelector('.p-open')?.classList.add('d-none');
            this.btnTogglePanel!.querySelector('.p-close')?.classList.remove('d-none');
            // shown.bs.offcanvas
        });
        this.offcanvasInstance?.show();
        this.btnApplyAll?.addEventListener('click', (e: Event) => {
            e.preventDefault();
            e.stopPropagation();
            this.applyAllAnalysedParameters();
        });
    }
    private applyAllAnalysedParameters(): void {
        // raccogli tutti i controlli block-analyzed-*
        const blocks = this.querySelectorAll('block-analyzed, block-analyzed-date, block-analyzed-ambito, block-analyzed-links');
        blocks.forEach(block => {
            (block as BlockAnalyzed).applyFromExternal();
        })
        toastSuccess(`Tutti i parametri sono stati applicati. Ricorda che i parametri devono essere gestiti a parte`);
    }
    protected render(): void {
        super.render();
    }
    static registerElement(): void {
        super.registerElement();
        // registra i componenti figli 
        BlockAnalyzed.registerElement();
        BlockAnalyzedDate.registerElement();
        BlockAnalyzedAmbito.registerElement();
        BlockAnalyzedLinks.registerElement();
        BlockAnalyzedParameters.registerElement();
    }
}